import axios from "./axios";

export default {
    getAllreport(id) {
        const options = {
            method: 'GET',
            url: `clinicalreport/${id}`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getFilterReport(params) {
        const options = {
            method: 'GET',
            url: `clinicalreport/filter`,
            headers: { 'content-type': 'application/json' },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
            })
        })
    },

    getNextCorrelative(baseCorrelative = '') {
        const options = {
            method: 'GET',
            url: `clinicalreport/next-correlative`,
            headers: { 'content-type': 'application/json' },
            params: { baseCorrelative }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    createreport(data, isFormData = false) {
        const options = {
            method: 'POST',
            url: `clinicalreport`,
            data: data
        };
        
        // If FormData, let Axios auto-detect content-type
        // Otherwise, set JSON header
        if (!isFormData) {
            options.headers = { 'content-type': 'application/json' }
        }
        
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    updatereport(id, data) {
        const options = {
            method: 'PUT',
            url: `clinicalreport/${id}`,
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    deletereport(id) {
        const options = {
            method: 'DELETE',
            url: `clinicalreport/${id}`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    }
}
